/**
 * Detect fn
 */
export default () => 'fill' in Array.prototype
